var searchCtrl = function($scope) {
	$scope.searchStr = '';

	$scope.submit = function(){	
		if($scope.searchStr) location.href = '/search/#!/search/'+$scope.searchStr;
	};

};

app.controller('SearchController', searchCtrl);